import { createContext, useContext } from "react"
import { type User, type LoginResponse } from "@/types/auth"

export interface AuthContextType {
	user: User | null
	token: string | null
	isLoading: boolean
	login: (data: LoginResponse, isSignup?: boolean) => Promise<void>
	logout: () => void
	isAuthenticated: boolean
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function useAuth() {
	const context = useContext(AuthContext)
	if (!context) throw new Error("useAuth must be used within an AuthProvider")
	return context
}
